import React, { useState } from "react"

export default function SubmitButtons({ quote, backRoute }) {
  const [disabled, setDisabled] = useState(false)

  const handleClick = () => {
    setDisabled(true)
    setTimeout(() => setDisabled(false), 5000)
  }

  return (
    <div className="quotes--form-submit-buttons">
      <a className="btn btn-outline-default btn-cancel-lg"
         href={backRoute}
      >
        {I18n.t("quotes.new.cancel")}
      </a>

      { quote.can_preview_pdf &&
        <input
          type="submit"
          className="btn btn-outline-default btn-cancel-lg"
          name="preview"
          formTarget="_blank"
          value={I18n.t("quotes.new.preview")}
        />
      }

      <input
        type="submit"
        className={`btn btn-primary ${disabled ? "disabled" : ""}`}
        value={I18n.t("quotes.new.generate")}
        onClick={handleClick}
      />

      <input
        type="submit"
        name="exit"
        className={`btn btn-primary ${disabled ? "disabled" : ""}`}
        value={I18n.t("quotes.new.generate_exit")}
        onClick={handleClick}
      />
    </div>
  )
}